import { render, staticRenderFns } from "./VerHistorialAcuerdoClientesBaseModal.vue?vue&type=template&id=986f9a38"
import script from "./VerHistorialAcuerdoClientesBaseModal.vue?vue&type=script&lang=js"
export * from "./VerHistorialAcuerdoClientesBaseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports